export default __webpack_public_path__ + "static/media/Mockupv2.f9481b54.png";